import React from 'react';
import {Link} from 'react-router-dom'
import {
  is_admin
} from '../helpers/'

class AdminMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      nav: null
    }
  }

  closeSidenav = () => {
    const {nav} = this.state
    nav.close()
  }

  componentWillMount = () => {
    window.setTimeout(function(self){
      const el = document.getElementById('slide-out')
      const nav = window.M.Sidenav.init(el)
      self.setState({nav: nav})
    }, 100, this)
  }

  render() {
    return (
      <div className="sidenav-container">
        <ul id="slide-out" className="sidenav">
          <li>
            <div>
              <a href='' className="btn-floating mr-10 waves-effect waves-light red" title="Close Administration Menu" onClick={ e=> {
                e.preventDefault()
                this.closeSidenav()
              }}><i className="material-icons white-text secondary-content">highlight_off</i>Close Admin Menu</a>
            </div>
          </li>
          <li>
            <i className="material-icons tiny mr-10">supervisor_account</i>Users
            <div className="divider"></div>
            <Link to="/users" className="waves-effect" title="List Users">
              <i className="material-icons tiny">people</i>List Users
            </Link>

            <Link to="/users/new" className="waves-effect" title="New User">
              <i className="material-icons tiny">person_add</i>New User
            </Link>
          </li>

          {
            is_admin() && (
              <React.Fragment>
                <li>
                  <i className="material-icons tiny mr-10">blur_linear</i>Accounts
                  <div className="divider"></div>
                  <Link to="/accounts" className="waves-effect" title="List Accounts">
                    <i className="material-icons tiny">menu</i>List Accounts
                  </Link>

                  <Link to="/accounts/new" className="waves-effect" title="New Account">
                    <i className="material-icons tiny">library_add</i>New Account
                  </Link>

                </li>
                <li>
                  <i className="material-icons tiny mr-10">build</i>Global Settings
                  <div className="divider"></div>

                  <Link to="/preferences" className="waves-effect" title="Manage Global Settings">
                    <i className="material-icons tiny">settings</i>Manage
                  </Link>

                </li>
              </React.Fragment>
            )
          }
        </ul>
        <a href="" data-target="slide-out" className="btn sidenav-trigger" title="Show Administration Menu">
          <i className="material-icons white-text secondary-content">build</i>Administration
        </a>
      </div>
  )

  }
}

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/js/components/AdminMenu.js